import { render, staticRenderFns } from "./shipped-product.vue?vue&type=template&id=6ed0eb77&"
import script from "./shipped-product.vue?vue&type=script&lang=js&"
export * from "./shipped-product.vue?vue&type=script&lang=js&"
import style0 from "./shipped-product.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports